"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.secondTypeReg = /\s2ndType\/([^\s]*)/i;
exports.dingTalkReg = /DingTalk/i;
exports.iPadReg = /iPad/i;
exports.macKeywords = 'Macintosh; Intel Mac OS';
exports.winKeywords = 'dingtalk-win';
exports.mobileDTVersionReg = /DingTalk\/([\d\.]+)/;
exports.pcDTVersionReg = /DingTalk\(([a-zA-Z0-9\.-]+)\)/;
exports.androidKeywords = 'Android';
exports.DEFAULT_VERSION = '100.0.0';
exports.iOSReg = /iPhone|iPad|iPod|iOS/i;
exports.miniAppRuntimeReg = /Nebula/i;
exports.webviewInMiniAppRuntimeReg = /dd-web/i;
exports.IDEKeywords = 'AlipayIDE';
var sendType;
(function (sendType) {
    sendType["LITE"] = "lite";
})(sendType = exports.sendType || (exports.sendType = {}));
;
